export function modalWindow() {
  document.querySelectorAll('.c-button__modal').forEach((modalButton) => {
    modalButton.addEventListener('click', showModal);
    function showModal() {
      const targetId = this.getAttribute('id');
      const targetContent = document.querySelector('.' + targetId);
      targetContent.classList.toggle('is-modal__active');
    }
  });
  document.querySelectorAll('.c-button__modal-close').forEach((modalCloseButton) => {
    modalCloseButton.addEventListener('click', closeModal);
    function closeModal() {
      const modalFadeOut = document.querySelector('.is-modal__active');
      modalFadeOut.classList.toggle('is-modal__fade');
      setTimeout(() => {
        const modalClose = document.querySelector('.is-modal__active');
        modalClose.classList.toggle('is-modal__active');
        modalClose.classList.toggle('is-modal__fade');
        removeChild();
      }, 500);
    }
  });
}

function removeChild() {
  const container = document.querySelector('.modal__content__data-area');
  for (let i = container.childNodes.length - 1; i >= 0; i--) {
    container.removeChild(container.childNodes[i]);
  }
}
